export default "__VITE_ASSET__Cxon2ONB__"